<template>
    <el-container>
        <!-- 标题 -->
        <el-header
            class="bg-blue"
            style="text-align: center;font-size: 30px;height:60px;line-height:60px;letter-spacing: 8px;">
            知识图谱
            <el-switch
                style="float: right;transform: translateY(100%);letter-spacing: 3px;"
                v-model="isShowCard"
                active-color="#13ce66"
                inactive-color="#e3e3e3"
                active-text="显示卡片"
                inactive-text="隐藏卡片"></el-switch>
        </el-header>
        <el-container :style="{height:useHeight +'px'}">
            <!-- 菜单栏 -->
            <el-aside width="250px" class="bg-blue">
                <el-autocomplete
                    v-model="keyword"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    style="width:100%"></el-autocomplete>
                <el-row>
                    <el-col :span="12">
                        <el-button type="success" style="width: 100%;" @click="addNewNode">创建节点</el-button>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" style="width: 100%;" @click="addNewEdge">创建关系</el-button>
                    </el-col>
                </el-row>
                <el-menu
                    background-color="#f1f2f3"
                    text-color="#000000"
                    active-text-color="#5a725a"
                    :default-openeds="['1']"
                    v-show="nodeList.length>0">
                    <el-submenu index="1">
                        <template slot="title">
                            <span>目录</span>
                        </template>
                        <el-menu-item
                            v-for="(item,index) in nodeList"
                            :index="''+item.id"
                            :key="item.id"
                            style="position: relative;"
                            @click.native="saveNode(item);nodeClick()">
                            <span v-if="item.properties" style="display:block;line-height:50px">{{item.properties.name}}</span>
                            <el-popover
                                placement="right"
                                width="100"
                                trigger="click"
                                style="position: absolute;right: 10px;top:0;">
                                <i
                                    class="el-icon-circle-plus-outline"
                                    @click.stop="saveNode(item);addNodeEdge()"></i>
                                <i class="el-icon-edit" @click.stop="saveNode(item);updateNode()"></i>
                                <i class="el-icon-delete" @click.stop="saveNode(item);deleteNodeEdge()"></i>
                                <el-button
                                    slot="reference"
                                    size="mini"
                                    type="info"
                                    plain="plain"
                                    round="round"
                                    class="el-icon-menu"
                                    @click.stop="saveNode(item);"></el-button>
                            </el-popover>
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <!-- 展示区 -->
            <el-main style="position: relative;">
                <svg id="canvas"></svg>
                <!-- 主节点卡片信息 -->
                <el-card
                    class="box-card"
                    style="position: absolute; top: 30px; right: 30px; width: 500px;"
                    v-if="isShowCard">
                    <div slot="header" class="clearfix">
                        <span>主节点信息</span>
                        <el-link type="primary" style="float: right;" v-if="mainNodeData.layer==2" @click="navToPractice(mainNodeData)">题库</el-link>
                    </div>
                    <el-form label-position="right" label-width="80px">
                        <el-form-item label="ID:">
                            <span>{{mainNodeData.id}}</span>
                        </el-form-item>
                        <el-form-item label="名称:">
                            <span>{{mainNodeData.name}}</span>
                        </el-form-item>
                        <el-form-item label="内容:">
                            <span v-html="mainNodeData.content"></span>
                        </el-form-item>
                        <el-form-item label="链接:">
                            <a
                                href="#"
                                @click="navToHref(mainNodeData.href)"
                                style="word-wrap: break-word;word-break: break-all;">{{mainNodeData.href}}</a>
                        </el-form-item>
                    </el-form>
                </el-card>
                <!-- 覆盖节点卡片信息 -->
                <el-card
                    class="box-card"
                    style="position: absolute; bottom: 30px; right: 30px; width: 500px;"
                    v-show="selectedNodeData.id">
                    <div slot="header" class="clearfix">
                        <span style="margin-right: 20px;">节点信息</span>
                    </div>
                    <el-form label-position="right" label-width="80px">
                        <el-form-item label="名称:">
                            <span>{{selectedNodeData.name}}</span>
                        </el-form-item>
                        <el-form-item label="内容:">
                            <span v-html="selectedNodeData.content"></span>
                        </el-form-item>
                        <el-form-item label="链接:">
                            <a
                                href="#"
                                @click="navToHref(selectedNodeData.href)"
                                style="word-wrap: break-word;word-break: break-all;">{{selectedNodeData.href}}</a>
                        </el-form-item>
                    </el-form>
                </el-card>
                <add-node ref="addNodeDialog" @msg="getMsg"></add-node>
                <add-edge ref="addEdgeDialog" @msg="getMsg"></add-edge>
                <update-node ref="updateNodeDialog" @msg="getMsg"></update-node>
                <test ref="testDialog"></test>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import addNode from './subComponents/addNode.vue'
    import addEdge from './subComponents/addEdge.vue'
    import updateNode from './subComponents/updateNode.vue'
    import test from './subComponents/test.vue'
    export default {
        name: "Book",
        components: {
            addNode,
            addEdge,
            updateNode,
            test
        },
        data() {
            return {
                // 可视区域高度
                useHeight: document.body.clientHeight - 60,
                // 关键字搜索
                keyword: "",
                // 搜索列表
                searchList: [],
                // 计时器
                timeout: null,
                // 节点信息
                svg: null,
                // 节点列表
                nodeList: [],
                // 边列表
                edgeList: [],
                // 主节点数据
                mainNodeData: {
                    id: ""
                },
                // 当前选中节点数据
                selectedNodeData: {
                    id: ""
                },
                // 卡片状态
                isShowCard: true
            }
        },
        created() {
            this.getAllData()
        },
        mounted() {
            this.refresh()
            this.d3Render()
        },
        methods: {
            // 窗体刷新
            refresh() {
                let _this = this;
                window.onresize = () => {
                    _this.useHeight = document.body.clientHeight - 60;
                }
            },
            // 获取节点
            async getAllNode() {
                let {data} = await this
                    .$http
                    .get('/node/getAllNode', {
                        params: {
                            id: this.selectedNodeData.id
                        }
                    })
                return data;
            },
            // 获取边
            async getAllEdge() {
                let {data} = await this
                    .$http
                    .get('/node/getAllEdge', {
                        params: {
                            id: this.selectedNodeData.id
                        }
                    });
                return data;
            },
            async getAllData() {
                this.nodeList = await this.getAllNode();
                this.edgeList = await this.getAllEdge();
                let data = this.composeData();
                this.d3jsonParser(data);
                this.d3Render();
                this.selectedNodeData = {};
                this.selectedNodeData.id = "";
                
                if (this.mainNodeData.id == "") {
                    this.mainNodeData.id = this.nodeList[0].id;
                    this.mainNodeData.name = this.nodeList[0].properties.name;
                    this.mainNodeData.content = this.nodeList[0].properties.content;
                    this.mainNodeData.layer = this.nodeList[0].properties.layer;
                    this.mainNodeData.note = this.nodeList[0].properties.note;
                    this.mainNodeData.href = this.nodeList[0].properties.href;
                }
            },
            // 数据处理
            composeData() {
                let d = [];
                let data = this.edgeList
                for (var i = 0; i < data.length; i++) {
                    let start = {
                        identity: data[i].startNode._id,
                        properties: {
                            name: data[i].startNode.name,
                            layer: data[i].startNode.layer,
                            note: data[i].startNode.note,
                            content: data[i].startNode.content,
                            href: data[i].startNode.href
                        }
                    };
                    let end = {
                        identity: data[i].endNode._id,
                        properties: {
                            name: data[i].endNode.name,
                            layer: data[i].endNode.layer,
                            note: data[i].endNode.note,
                            content: data[i].endNode.content,
                            href: data[i].endNode.href
                        }
                    };
                    let segments = [
                        {
                            start: start,
                            relationship: {
                                identity: data[i]._id,
                                start: data[i].startNode._id,
                                end: data[i].endNode._id,
                                properties: {
                                    name: data[i].name
                                }
                            },
                            end: end
                        }
                    ];
                    let length = "1.0";
                    d.push({start, segments, end, length});
                }
                return d;
            },
            // 数据格式转换
            d3jsonParser(json) {
                const nodes = []; // 节点
                const links = []; // 关系
                const nodeSet = []; // 去重节点id
                for (let item of json) {
                    for (let segment of item.segments) {
                        if (nodeSet.indexOf(segment.start.identity) == -1) {
                            nodeSet.push(segment.start.identity);
                            nodes.push({id: segment.start.identity, properties: segment.start.properties});
                        }
                        if (nodeSet.indexOf(segment.end.identity) == -1) {
                            nodeSet.push(segment.end.identity);
                            nodes.push({id: segment.end.identity, properties: segment.end.properties});
                        }
                        links.push(
                            {id: segment.relationship.identity, source: segment.relationship.start, target: segment.relationship.end, properties: segment.relationship.properties}
                        );
                    }
                }

                // 加入孤立的节点
                for (let i = 0; i < this.nodeList.length; i++) {
                    if (nodeSet.indexOf(this.nodeList[i]._id) == -1) {
                        nodeSet.push(this.nodeList[i]._id);
                        nodes.push({
                            id: this
                                .nodeList[i]
                                ._id,
                            properties: {
                                name: this
                                    .nodeList[i]
                                    .name,
                                layer: this
                                    .nodeList[i]
                                    .layer,
                                note: this
                                    .nodeList[i]
                                    .note,
                                content: this
                                    .nodeList[i]
                                    .content,
                                href: this
                                    .nodeList[i]
                                    .href
                            }
                        });
                    }
                }
                this.nodeList = nodes;
                this.edgeList = links;

                // 前后端换行渲染处理  /n -> <br/>
                this.nodeList.map((item) => {
                    item.properties.content = item.properties.content.replace(/\\n/g, "<br/>")
                })

                this.loadAll()
            },
            // 测试函数
            d3Render() {
                let _this = this;
                this.svg = d3
                    .select("#canvas")
                    .attr("width", 1400)
                    .attr("height", this.useHeight);

                var width = this
                    .svg
                    .attr("width");
                var height = this
                    .svg
                    .attr("height");

                _this
                    .svg
                    .select("*")
                    .remove()
                var nodes = this.nodeList;
                var edges = this.edgeList;

                var g = _this
                    .svg
                    .call(d3.zoom().scaleExtent([0.1, 3]).on("zoom", function () {
                        g.attr("transform", d3.event.transform)
                    }))
                    .append("g");
                // 新建一个颜色比例尺
                // var scaleColor = d3
                //     .scaleOrdinal()
                //     .domain(d3.range(nodes.length))
                //     .range(d3.schemeCategory10);
                var scaleColor = ["#1776B6","#FF7F00","#24A221","#D8241F","#9564BF"]
                // 新建一个力导向图
                var forceSimulation = d3
                    .forceSimulation()
                    .force("link", d3.forceLink())
                    .force("charge", d3.forceManyBody().strength(-50))
                    .force("center", d3.forceCenter())
                    .force("collision", d3.forceCollide().radius((d) => {
                        return 40;
                    }).iterations(0.15).strength(0.75));
                // 自定义识别的索引值
                var hash_lookup = [];
                nodes.forEach(function (d, i) {
                    hash_lookup[d.id] = d;
                });
                edges.forEach(function (d, i) {
                    d.source = hash_lookup[d.source];
                    d.target = hash_lookup[d.target];
                });
                // 生成节点数据
                forceSimulation
                    .nodes(nodes)
                    .on('tick', linksTick);
                // 生成边数据
                forceSimulation
                    .force('link')
                    .links(edges)
                    .distance(function (d, i) {
                        return 150; // 设置边长
                    });
                // 设置图形中心点
                forceSimulation
                    .force('center')
                    .x(width / 2) // 设置x坐标
                    .y(height / 2); // 设置y坐标
                // 顶点数据 和 边数据 
                var links = g
                    .append('g')
                    .attr("class", "links")
                    .selectAll('line')
                    .data(edges)
                    .enter()
                    // .append('line')
                    .append("path")
                    .attr("id", function(d, i) {
                        return "edgePath"+i;
                    })
                    .attr("fill", "none")
                    .attr('stroke', function (d, i) {
                        return "#000000" // 设置边线颜色
                    })
                    .attr('storke-width', 2) // 设置边线宽度
                    
                // 绘制边上的文字
                var linksText = g
                    .append('g')
                    .attr("class", "linkTexts")
                    .selectAll('text')
                    .data(edges)
                    .enter()
                    .append('text')
                    .attr("text-anchor", "middle") // 路径文字居中
                    .attr("font-size", 12)
                    .append("textPath")
                    .attr("xlink:href", function(d, i) {
                        return '#edgePath'+i;
                    })
                    .attr("startOffset", "50%") // 路径文字居中
                    .text(function (d, i) {
                        return d.properties.name;
                    })

                // 创建节点分组
                var gs = g
                    .append("g")
                    .selectAll('.circle')
                    .data(nodes)
                    .enter()
                    .append('g')
                    .attr("class", "nodes")
                    .attr('transform', function (d, i) {
                        return 'translate(' + d.x + ',' + d.y + ')'
                    })
                    .call(d3.drag() // 相当于移动端的拖拽手势  分以下三个阶段
                        .on('start', start).on('drag', drag).on('end', end))
                    .on("mouseenter", function (event) {
                        // 更改节点点击状态
                        // 当前选中节点
                        var node = d3.select(this);
                        var properties = node
                            ._groups[0][0]
                            .__data__
                            .properties;
                        let id = node
                            ._groups[0][0]
                            .__data__
                            .id;
                        let name = properties.name;
                        let layer = properties.layer;
                        let note = properties.note;
                        let content = properties.content;
                        let href = properties.href;
                        _this.$set(_this.selectedNodeData, "id", id);
                        _this.$set(_this.selectedNodeData, "name", name);
                        _this.$set(_this.selectedNodeData, "layer", layer);
                        _this.$set(_this.selectedNodeData, "note", note);
                        _this.$set(_this.selectedNodeData, "content", content);
                        _this.$set(_this.selectedNodeData, "href", href);
                        // 更改图样式
                        _this.changeGrapgStyle(id);
                    })
                    .on("mouseleave", (event) => {
                        // 更改节点点击状态
                        this.clearGraphStyle();
                    })
                    .on("click", this.nodeClick);
                // 绘制节点
                gs
                    .append('circle')
                    .attr('r', 24)
                    .attr('fill', function (d, i) {
                        // return scaleColor(d.properties.layer);
                        return scaleColor[d.properties.layer]
                    });
                // 绘制文字
                gs
                    .append('text')
                    .attr("text-anchor", "middle") // 节点文本居中
                    .attr("x", function(d) {
                        return textBreaking(d3.select(this), d.properties.name);
                    })
                    .attr("font-size", 12)

                // 文本分隔（根据字数在当前选择器中分隔三行，超过5字省略）
                function textBreaking(d3Text, text) {
                    const len = text.length;
                    if (len <= 2) {
                        d3Text.append("tspan").attr("x", 0).attr("y", 5).text(text);
                    } else {
                        const topText = text.substring(0, 2);
                        const midText = text.substring(2, 5);
                        let botText = text.substring(5, len);
                        let topY = -16;
                        let midY = 0;
                        let botY = 12;
                        if (len <= 5) {
                            topY += 12;
                            midY += 12;
                        } else if (len > 5) {
                            topY += 10;
                            midY += 10;
                            botY += 5;
                            botText = "..."
                        }

                        d3Text.text("");
                        d3Text
                            .append("tspan")
                            .attr("x", 0)
                            .attr("y", topY)
                            .text(function () {
                                return topText;
                            });
                        d3Text
                            .append("tspan")
                            .attr("x", 0)
                            .attr("y", midY)
                            .text(function () {
                                return midText;
                            });
                        d3Text
                            .append("tspan")
                            .attr("x", 0)
                            .attr("y", botY)
                            .text(function () {
                                return botText;
                            });
                    }
                }

                function linksTick() {
                    // 直线path
                    // links
                    //     .attr("x1", function (d) {
                    //         return d.source.x;
                    //     })
                    //     .attr("y1", function (d) {
                    //         return d.source.y;
                    //     })
                    //     .attr("x2", function (d) {
                    //         return d.target.x;
                    //     })
                    //     .attr("y2", function (d) {
                    //         return d.target.y;
                    //     });

                    links.attr("d", function(d) {
                        // 两点间的x轴夹角弧度
                        var xAngle=Math.atan2((d.target.y-d.source.y), (d.target.x-d.source.x));
                        // 转为角度
                        var xAngle = 360*xAngle/(2*Math.PI);
                        var angle = 30;
                        // 两点间的长度
                        var L=Math.sqrt((d.target.y-d.source.y)*(d.target.y-d.source.y)+(d.target.x-d.source.x)*(d.target.x-d.source.x));
                        // 计算等腰三角形斜边长度
                        var L2 = L/2 / Math.cos(30* 2*Math.PI/360);

                        var Qx1=d.source.x+Math.round(L2 * Math.cos((xAngle-angle/2)* 2 * Math.PI/360));
                        var Qy1=d.source.y+Math.round(L2 * Math.sin((xAngle-angle/2)* 2 * Math.PI/360));
                        var Qx2=d.source.x+Math.round(L2 * Math.cos((xAngle+angle/2)* 2 * Math.PI/360));
                        var Qy2=d.source.y+Math.round(L2 * Math.sin((xAngle+angle/2)* 2 * Math.PI/360));

                        if (d.source.x < d.target.x) {
                            return "M " + d.source.x + " " + d.source.y + " Q " + Qx1 + " " + Qy1 + " " + d.target.x + " " + d.target.y 
                        } else if (d.source.x >= d.target.x) {
                            return "M " + d.target.x + " " + d.target.y + " Q " + Qx1 + " " + Qy1 + " " + d.source.x + " " + d.source.y 
                        }
                    })
                    .attr("marker-end", function(d) {
                        if (d.source.x < d.target.x) {
                            return "url(#posMarkerEnd)";
                        }
                        return '';
                    })
                    .attr("marker-start", function(d) {
                        if (d.source.x >= d.target.x) {
                            return "url(#posMarkerStart)";
                        }
                        return '';
                    })

                    // 根据点设置边名称位置
                    // linksText.attr("transform", (d) => {
                    //     let x = Math.min(d.source.x, d.target.x) + Math.abs(d.source.x - d.target.x) / 2;
                    //     let y = Math.min(d.source.y, d.target.y) + Math.abs(d.source.y - d.target.y) / 2 - 6;

                    //     let tanA = Math.abs(d.source.y - d.target.y) / Math.abs(d.source.x - d.target.x);
                    //     let angle = (Math.atan(tanA) / Math.PI) * 180;
                    //     if (d.source.x > d.target.x) {
                    //         // 第二象限
                    //         if (d.source.y <= d.target.y) {
                    //             angle = -angle;
                    //         }
                    //     } else if (d.source.y > d.target.y) {
                    //         // 第一象限
                    //         angle = -angle;
                    //     }
                    //     return "translate(" + x + "," + y + ")rotate(" + angle + ")";
                    // });

                    linksText
                    .attr('dominant-baseline', function(d) {
                        // 控制文字在弧上方
                        if (d.source.x < d.target.x) {
                            return 'text-after-edge';
                        }
                        return 'text-before-edge';
                    });

                    gs && gs.attr('transform', function (d, i) {
                        return 'translate(' + d.x + ',' + d.y + ')';
                    })
                }

                function start(d) {
                    if (!d3.event.active) { // 判断拖拽手势的 start 事件和 end 事件: 开始时为0，拖拽结束最后一个手势事件时为0
                        // drag的过程中
                        forceSimulation
                            .alphaTarget(0.3)
                            .restart(); // 设置衰减系数，数值越高移动越快[0，1]
                    }
                    d.fx = d.x;
                    d.fy = d.y;
                }
                function drag(d) {
                    d.fx = d3.event.x;
                    d.fy = d3.event.y;
                }
                function end(d) {
                    if (!d3.event.active) {
                        forceSimulation.alphaTarget(0);
                    }
                    // 注释以下代码, 拖动结束后固定节点
                    d.fx = null;
                    d.fy = null;
                }

                // 增加箭头
                var defs = g.append("defs");
                const posMarkerEnd = defs
                    .append("marker")
                    .attr("id", "posMarkerEnd")
                    .attr("orient", "auto")
                    .attr("stroke-with", 2)
                    .attr("markerUnits", "strokeWidth")
                    .attr("markerUnits", "userSpaceOnUse")
                    .attr("viewBox", "0 -5 10 10")
                    .attr("refX", 30)  // 31
                    .attr("refY", -2)  // 0
                    .attr("markerWidth", 11) 
                    .attr("markerHeight", 11) 
                    .append("path")
                    .attr("d", "M 0 -5 L 10 0 L 0 5")
                    .attr("fill", "rgb(0,0,0)")
                    .attr("stroke-opacity", 0.6);
                const posActMarkerEnd = defs
                    .append("marker")
                    .attr("id", "posActMarkerEnd")
                    .attr("orient", "auto")
                    .attr("stroke-width", 2)
                    .attr("markerUnits", "strokeWidth")
                    .attr("markerUnits", "userSpaceOnUse")
                    .attr("viewBox", "0 -5 10 10")
                    .attr("refX", 30)  // 31
                    .attr("refY", -2)  // 0
                    .attr("markerWidth", 11) 
                    .attr("markerHeight", 11)
                    .append("path")
                    .attr("d", "M 0 -5 L 10 0 L 0 5")
                    .attr("fill", "rgb(122, 188, 255)")
                    .attr("stroke-opacity", 0.8);
                const posMarkerStart = defs
                    .append("marker")
                    .attr("id", "posMarkerStart")
                    .attr("orient", "auto")
                    .attr("stroke-with", 2)
                    .attr("markerUnits", "strokeWidth")
                    .attr("markerUnits", "userSpaceOnUse")
                    .attr("viewBox", "0 -5 10 10")
                    .attr("refX", -20)
                    .attr("refY", 2) 
                    .attr("markerWidth", 11) 
                    .attr("markerHeight", 11) 
                    .append("path")
                    .attr("d", "M 0 0 L 10 -5 L 10 5")
                    .attr("fill", "rgb(0,0,0)")
                    .attr("stroke-opacity", 0.6);
                const posActMarkerStart = defs
                    .append("marker")
                    .attr("id", "posActMarkerStart")
                    .attr("orient", "auto")
                    .attr("stroke-with", 2)
                    .attr("markerUnits", "strokeWidth")
                    .attr("markerUnits", "userSpaceOnUse")
                    .attr("viewBox", "0 -5 10 10")
                    .attr("refX", -20)  
                    .attr("refY", 2)  
                    .attr("markerWidth", 11) 
                    .attr("markerHeight", 11) 
                    .append("path")
                    .attr("d", "M 0 0 L 10 -5 L 10 5")
                    .attr("fill", "rgb(122, 188, 255)")
                    .attr("stroke-opacity", 0.8);
            },
            // 根据节点id变换图样式
            changeGrapgStyle(id) {
                this
                    .svg
                    .selectAll(".nodes")
                    .selectAll("circle")
                    .attr("class", (d) => {
                        if (d.id == id) {
                            // 为选中节点增加样式
                            return "nodesFixed"
                        } else {
                            // 为相邻节点增加样式
                            for (var i = 0; i < this.edgeList.length; i++) {
                                if (this.edgeList[i]["source"].id == id && this.edgeList[i]["target"].id == d.id) {
                                    return "nodesActive"
                                }
                                if (this.edgeList[i]["target"].id == id && this.edgeList[i]["source"].id == d.id) {
                                    return "nodesActive"
                                }
                            }
                            return "nodesInActive"
                        }
                    })
                // 相邻文字是否隐藏
                this
                    .svg
                    .selectAll("nodes")
                    .selectAll("text")
                    .attr("class", (d) => {
                        if (d.id = id) {
                            return ""
                        } else {
                            for (var i = 0; i < this.edgeList.length; i++) {
                                if (this.edgeList[i]["source"].id == id || this.edgeList[i]["target"].id == id) {
                                    return ""
                                }
                            }
                        }
                    })
                // 相邻边是否隐藏
                this
                    .svg
                    .select(".links")
                    // .selectAll("line")
                    .selectAll("path")
                    .attr("class", (d) => {
                        if (d.source.id == id || d.target.id == id) {
                            return "linksActive"
                        } else {
                            return "linksInActive"
                        }
                    })
                    .attr("marker-end", (d) => {
                        if (d.source.id == id || d.target.id == id) {
                            if (d.source.x < d.target.x) {
                                return "url(#posActMarkerEnd)";
                            }
                        } else {
                            if (d.source.x < d.target.x) {
                                return "url(#posMarkerEnd)";
                            }
                        }
                    })
                    .attr("marker-start", (d) => {
                        if (d.source.id == id || d.target.id == id) {
                            if (d.source.x >= d.target.x) {
                                return "url(#posActMarkerStart)";
                            }
                        } else {
                            if (d.source.x >= d.target.x) {
                                return "url(#posMarkerStart)";
                            }
                        }
                    })
                // 相邻边文字是否隐藏
                this
                    .svg
                    .select(".linkTexts")
                    .selectAll("text")
                    .attr("class", (d) => {
                        if (d.source.id == id || d.target.id == id) {
                            return "linkTextsActive"
                        } else {
                            return "linkTextsInActive"
                        }
                    })
            },
            // 移除所有样式
            clearGraphStyle() {
                this
                    .svg
                    .select(".links")
                    .selectAll("path")
                    .attr("class", "")
                    .attr("marker-end", (d) => {
                        if (d.source.x < d.target.x) {
                            return "url(#posMarkerEnd)"
                        }
                    })
                    .attr("marker-start", (d) => {
                        if (d.source.x >= d.target.x) {
                            return "url(#posMarkerStart)"
                        }
                    })
                this
                    .svg
                    .select(".linkTexts")
                    .selectAll("text")
                    .attr("class", "");
                this
                    .svg
                    .selectAll(".nodes")
                    .selectAll("circle")
                    .attr("class", "");
                this
                    .svg
                    .selectAll(".nodes")
                    .selectAll("text")
                    .attr("class", "");
                this.selectedNodeData = {}
            },
            // 点击节点，固定信息
            nodeClick() {
                this.mainNodeData.id = this.selectedNodeData.id;
                this.mainNodeData.name = this.selectedNodeData.name;
                this.mainNodeData.content = this.selectedNodeData.content;
                this.mainNodeData.layer = this.selectedNodeData.layer;
                this.mainNodeData.note = this.selectedNodeData.note;
                this.mainNodeData.href = this.selectedNodeData.href;

                // 跳转点击节点
                this.getAllData();
            },
            // 新增节点
            addNewNode() {
                this
                    .$refs
                    .addNodeDialog
                    .getNodeInfo("newNode");
            },
            // 新增边
            addNewEdge() {
                if (this.nodeList == 0) {
                    this
                        .$message
                        .warning("当前没有可选节点")
                } else {
                    this
                        .$refs
                        .addEdgeDialog
                        .getNodeInfo(this.nodeList);
                }
            },
            // 新增节点和边
            addNodeEdge() {
                if (this.selectedNodeData.id != '' && this.selectedNodeData.id != null) {
                    this
                        .$refs
                        .addNodeDialog
                        .getNodeInfo(this.selectedNodeData)

                } else {
                    this
                        .$message
                        .warning("请选择主节点")
                }
            },
            getMsg(msg) {
                this.selectedNodeData = {}
                this.selectedNodeData.id = ""
                this.getAllData()
                if (msg == "addNode") {
                    this
                        .$message
                        .success("节点新增成功")
                } else if (msg == "updateNode") {
                    this
                        .$message
                        .success("节点修改成功")
                }
            },
            //修改节点
            updateNode() {
                if (this.selectedNodeData.id != '' && this.selectedNodeData.id != null) {
                    this
                        .$refs
                        .updateNodeDialog
                        .getNodeInfo(this.selectedNodeData)
                } else {
                    this
                        .$message
                        .warning("请选择主节点")
                }
            },
            //删除节点和边
            deleteNodeEdge() {
                let id = this.selectedNodeData.id
                if (this.selectedNodeData.id != '' && this.selectedNodeData.id != null) {
                    this
                        .$confirm('此操作将永久删除该节点及其关系, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        .then(() => {
                            this
                                .$http
                                .get("/node/deleteNodeEdge", {
                                    params: {
                                        id: id
                                    }
                                })
                                .then((res) => {
                                    if (res.data) {
                                        this.selectedNodeData = {}
                                        this.selectedNodeData.id = ""
                                        this.getAllData()
                                        this.$message({type: 'success', message: '节点删除成功!'});
                                    }
                                })
                        })
                        .catch(() => {
                            this.$message({type: 'info', message: '已取消删除'});
                        });

                } else {
                    this
                        .$message
                        .warning("请选择主节点")
                }
            },
            // 根据关键字模糊搜索
            async searchNodeByName() {
                let {data} = await this
                    .$http
                    .get("/node/searchNodeByName", {
                        params: {
                            keyword: this.keyword
                        }
                    });
                return data;
            },
            // 模拟图节点 鼠标进入,高亮节点和关系
            mouseenterItem(item, index) {
                this.$set(this.selectedNodeData, "id", item.id);
                this.$set(this.selectedNodeData, "name", item.properties.name);
                this.$set(this.selectedNodeData, "layer", item.properties.layer);
                this.$set(this.selectedNodeData, "note", item.properties.note);
                this.$set(this.selectedNodeData, "content", item.properties.content);
                this.$set(this.selectedNodeData, "href", item.properties.href);
                // 更改图样式
                this.changeGrapgStyle(item.id);
            },
            querySearchAsync(queryString, cb) {
                var data = this.searchList;
                var results = queryString
                    ? data.filter(this.createStateFilter(queryString))
                    : data;

                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    cb(results);
                }, 3000 * Math.random());
            },
            createStateFilter(queryString) {
                return(state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
                };
            },
            handleSelect(item) {
                this.selectedNodeData = item
                this.nodeClick();
                // this.isNextNode = true;
                // this.getAllData();
            },
            loadAll() {
                this.searchList = []
                for (let i = 0; i < this.nodeList.length; i++) {
                    this
                        .searchList
                        .push({
                            id: this
                                .nodeList[i]
                                .id,
                            value: this
                                .nodeList[i]
                                .properties
                                .name,
                            layer: this
                                .nodeList[i]
                                .properties
                                .layer,
                            note: this
                                .nodeList[i]
                                .properties
                                .note,
                            content: this
                                .nodeList[i]
                                .properties
                                .content
                        });
                }
            },
            // 保存节点信息
            saveNode(item) {
                this.$set(this.selectedNodeData, "id", item.id);
                this.$set(this.selectedNodeData, "name", item.properties.name);
                this.$set(this.selectedNodeData, "layer", item.properties.layer);
                this.$set(this.selectedNodeData, "note", item.properties.note);
                this.$set(this.selectedNodeData, "content", item.properties.content);
                this.$set(this.selectedNodeData, "href", item.properties.href)
            },
            // 链接跳转
            navToHref(href) {
                window.open(href);
            },
            // 题库跳转
            navToPractice(mainNodeData) {
                // let {href} = this.$router.resolve({
                //     path: '/practice'
                // });
                // localStorage.setItem("node", JSON.stringify(mainNodeData));
                // window.open(href, '_blank');

                this
                    .$refs
                    .testDialog
                    .getNodeInfo(mainNodeData)
            }
        }
    }
</script>

<style lang="less">
    .nodesFixed {
        stroke: rgb(207, 236, 255);
        stroke-width: 6px;
        stroke-opacity: 0.8;
    }
    .nodesActive {
        stroke: rgb(122, 188, 255);
        stroke-width: 6px;
        stroke-opacity: 0.8;
    }
    .nodes:hover {
        cursor: pointer;
    }
    .linksActive {
        stroke: rgb(122, 188, 255);
        stroke-width: 2px;
        stroke-opacity: 0.5;
    }
    .linkTextsActive {
        color: rgb(122, 188, 255);
        font-weight: bold;
    }
    .nodesInActive .linksInActive .linkTextsInActive {
        opacity: 0.15;
    }
    .el-main {
        padding: 0;
    }
    .el-form-item {
        margin-bottom: 10px;
    }
    .el-form-item__content,
    .el-form-item__label {
        line-height: 20px;
    }
    .el-button {
        margin-left: 0;
    }
    .el-button--mini,
    .el-button--mini.is-round {
        padding: 7px;
    }
    .el-popover {
        min-width: 10px;
        font-size: 20px;
    }
    .el-popover i:hover {
        cursor: pointer;
        color: #00bb00;
    }
    .el-switch__label.is-active {
        color: #13ce66;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/Book.vue